module.exports = __webpack_public_path__ + "static/group1_4-33f4d4f9ef852b2a7e97114d7442edbf.webp";